// INFO: only use this store module for ssr/hydration reasons for fetched data by api
export default () => ({
  rawVehicleData: null,
  rawCrossSellingVehicleData: null,
  hasFoundVehicle: true
})
